import { useParams } from "react-router-dom";
import useRequestId from "../../hooks/DatabseCollection/useRequestId";
import RequestCard from "../RequestCard/RequestCard";

const RequestTab = () => {
  const { roomId } = useParams();

  const [requestData] = useRequestId(roomId);

  return (
    <div className="">
      {requestData.length <= 0 && <h1>No Requests</h1>}
      <div className="sm:grid sm:gap-8 sm:grid-cols-2 lg:grid-cols-3 space-y-8 sm:space-y-0">
        {requestData.map(
          ({
            id,
            data: { memberName, memberImage, memberId, memberEmail, isAdmin },
          }) => (
            <RequestCard
              key={id}
              id={id}
              memberName={memberName}
              memberEmail={memberEmail}
              memberImage={memberImage}
              memberId={memberId}
              isAdmin={isAdmin}
            />
          )
        )}
      </div>
    </div>
  );
};

export default RequestTab;
